<template>
    <!-- authenticated but wrong care network or PCC 
    Please note this href is hard-coded to a page in prod bc it does not exist in lower environments -->
    <ResultsNetworkBanner bannerType="error" header="Out of network.">
        <span>You’ll only get coverage when you use your designated primary care clinic’s care network. To get coverage at this provider,
            <a :data-card-rank="rank" target="_blank" href="https://www.healthpartners.com/lp/insurance/members/change-pcc-auth-instructions/"
                >change your primary care clinic.</a
            >
        </span>
    </ResultsNetworkBanner>    
</template>

<script setup> 
    const props = defineProps({
        rank: Number
    })
</script>